import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69f81942f6558f001429978c/frictionscan/src/app/page.tsx");
